import React from 'react'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text-v1'

import { PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { CardSummary } from 'app/KinerjaPSPegawaiPage/components/CardSummary'
import { DialogConfirmation } from 'app/KinerjaPSPegawaiPage/components/DialogConfirmation'
import { PENGEMBANGAN_KOMPETENSI_ACTIVITY_LOCATION } from 'app/KinerjaPenilikPegawaiPage/constants/pengembanganKompetensi'

import type { Perencanaan } from 'types/kinerja-penilik-pegawai'

type TDialogChangePengembanganKompetensiProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}
const DialogChangePengembanganKompetensi: React.FC<
  TDialogChangePengembanganKompetensiProps
> = ({ isOpen, onClose, onConfirm }) => {
  return (
    <DialogConfirmation
      isOpen={isOpen}
      autoFocus={false}
      returnFocus={false}
      size="sm"
      title="Ubah Pengembangan Kompetensi?"
      description="Setelah diubah, pastikan Anda lanjut mengajukan Perencanaan."
      ctaConfirm="Ke Pengembangan Kompetensi"
      onClickConfirm={onConfirm}
      onClickCancel={onClose}
    />
  )
}

type TSectionPengembanganKompetensiProps = {
  data: Perencanaan
  showRightAction?: boolean
}
export const SectionPengembanganKompetensi: React.FC<
  TSectionPengembanganKompetensiProps
> = ({ data, showRightAction = false }) => {
  const router = useRouter()
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false)

  return (
    <>
      <CardSummary
        title="Pengembangan Kompetensi"
        {...(showRightAction && {
          onChangeClicked: () => setIsDialogOpen(true),
        })}
      >
        <div className="p-6 space-y-8 bg-white gap-x-4 rounded-b-md">
          <div className="grid grid-cols-12 gap-x-6">
            <div className="col-span-2">
              <Text variant="subheading" className="uppercase">
                {data?.pengembanganKompetensiIndikator?.section}
              </Text>
            </div>
            <div className="col-span-10">
              <Text>{data?.pengembanganKompetensiIndikator?.deskripsi}</Text>
            </div>
          </div>

          {(data?.pengembanganKompetensiKegiatanValues ?? []).map(
            (item, index) => (
              <div key={index} className="grid grid-cols-12 gap-x-6">
                <div className="col-span-2">
                  <Text variant="subheading" className="uppercase">
                    Kegiatan {index + 1}
                  </Text>
                </div>
                <div className="col-span-10 space-y-1">
                  <Text variant="helper-bold">
                    {
                      PENGEMBANGAN_KOMPETENSI_ACTIVITY_LOCATION[
                        item?.tempatMeningkatkanIndikator
                      ]
                    }
                  </Text>
                  <Text>{item?.kegiatan?.jenisKegiatan}</Text>
                </div>
              </div>
            )
          )}
        </div>
      </CardSummary>

      <DialogChangePengembanganKompetensi
        isOpen={isDialogOpen}
        onConfirm={() => {
          router.push(
            `${PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH}/perencanaan/pengembangan-kompetensi`
          )
          setIsDialogOpen(false)
        }}
        onClose={() => {
          setIsDialogOpen(false)
        }}
      />
    </>
  )
}
